import { PROJECTS_SERVICE } from "@/services/projects.service.js";

const state = {postProjectOutput: false, getProjectsOutput: {}, putProjectOutput: false, getProjectByIdOutput: {}, deleteProjectByIdOutput: false, getProjectBySlugOutput: {}};

const actions = {
    //Service to create Projects
    postProject({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postProjectRequest');

        PROJECTS_SERVICE.postProject(input)
            .then(
                output => {
                    commit('postProjectSuccess', output);
                },
                error => {
                    commit('postProjectFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated Projects
    getProjects({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getProjectsRequest');

        PROJECTS_SERVICE.getProjects(queryParams)
            .then(
                output => {
                    commit('getProjectsSuccess', output);
                },
                error => {
                    commit('getProjectsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update Projects
    putProject({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putProjectRequest');

        PROJECTS_SERVICE.putProject(input)
            .then(
                output => {
                    commit('putProjectSuccess', output);
                },
                error => {
                    commit('putProjectFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get Project details
    getProjectById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getProjectByIdRequest');

        PROJECTS_SERVICE.getProjectById(id)
            .then(
                output => {
                    commit('getProjectByIdSuccess', output);
                },
                error => {
                    commit('getProjectByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete Projects
    deleteProjectById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteProjectByIdRequest');

        PROJECTS_SERVICE.deleteProjectById(id)
            .then(
                output => {
                    commit('deleteProjectByIdSuccess', output);
                },
                error => {
                    commit('deleteProjectByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get Project details
    getProjectBySlug({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getProjectBySlugRequest');

        PROJECTS_SERVICE.getProjectBySlug(queryParams)
            .then(
                output => {
                    commit('getProjectBySlugSuccess', output);
                },
                error => {
                    commit('getProjectBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postProject
    postProjectRequest(state) {
        state.postProjectOutput = null;
    },
    postProjectSuccess(state, output) {
        state.postProjectOutput = true;
    },
    postProjectFailure(state) {
        state.postProjectOutput = false;
    },

    //getProjects
    getProjectsRequest(state) {
    },
    getProjectsSuccess(state, output) {
        state.getProjectsOutput = output;
    },
    getProjectsFailure(state) {
        state.getProjectsOutput = false;
    },

    //putProject
    putProjectRequest(state) {
        state.putProjectOutput = null;
    },
    putProjectSuccess(state, output) {
        state.putProjectOutput = true;
    },
    putProjectFailure(state) {
        state.putProjectOutput = false;
    },

    //getProjectById
    getProjectByIdRequest(state) {
    },
    getProjectByIdSuccess(state, output) {
        state.getProjectByIdOutput = output;
    },
    getProjectByIdFailure(state) {
        state.getProjectByIdOutput = false;
    },

    //deleteProjectById
    deleteProjectByIdRequest(state) {
        state.deleteProjectByIdOutput = null;
    },
    deleteProjectByIdSuccess(state, output) {
        state.deleteProjectByIdOutput = true;
    },
    deleteProjectByIdFailure(state) {
        state.deleteProjectByIdOutput = false;
    },

    //getProjectBySlug
    getProjectBySlugRequest(state) {
    },
    getProjectBySlugSuccess(state, output) {
        state.getProjectBySlugOutput = output;
    },
    getProjectBySlugFailure(state) {
        state.getProjectBySlugOutput = false;
    },
};

export const projects = {
    namespaced: true,
    state,
    actions,
    mutations
};